<div class="modal-header">
    <h1 class="modal-title">{{ headerText }}</h1>
</div>
<div class="modal-body">
    <p>{{ bodyText }}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal()">{{ closeButtonText }}</button>
</div>